<form [formGroup]="formGroup">
  <p-autocomplete
    [ngClass]="{
      'ng-invalid': invalid,
      'ng-dirty': invalid,
    }"
    [style]="{ width: '100%', 'min-width': '250px' }"
    formControlName="address"
    [inputId]="inputId"
    [ariaLabel]="ariaLabel"
    [required]="true"
    [inputStyle]="{ width: '100%' }"
    class="ng-invalid ng-dirty flex-grow"
    [suggestions]="filteredAddress"
    (completeMethod)="filterAddress($event)"
    [placeholder]="'calculator.placeholder.' + placeholder | transloco"
    forceSelection="true"
    [showClear]="true"
  />
  <app-error [control]="formGroup.get('address')!" />
</form>
